<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>{{isStep}}. Tariff</v-card-title>
        <v-card-text>
          <span :class="(detectChanges)?'error--text':'body--text'">
            <b>Current</b><br>
            Tariff <span class="float-right">{{formData.iniTariff.name}} £{{formData.iniTariff.price.toFixed(2)}}</span><br>
            Contract Length <span class="float-right">{{formData.iniCLength}} Months</span><br>
            Promo <span class="float-right">{{formData.iniPromo.name}}</span><br>
          </span>
          <template v-if="detectChanges">
            <v-divider class="my-2"></v-divider>
            <span class="secondary--text">
              <b>Updated</b><br>
              Tariff <span class="float-right">{{formData.tariff.name}} £{{formData.tariff.price.toFixed(2)}}</span><br>
              Contract Length 
              <span class="float-right">
                <template v-if="formData.cLength!==''">{{(formData.cLength===1)?`Month to Month`:`${formData.cLength} Months`}}</template>
                <template v-else><b>not selected</b></template>
              </span><br>
              
              Promo 
              <span class="float-right">
                <template v-if="formData.promo.id!==''">{{formData.promo.name}}</template>
                <template v-else><b>removed</b></template>
              </span><br>
            </span>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: [ 'isStep','formData' ],
    computed: {
      detectChanges() {
        let fd = this.formData;
        if(fd.iniTariff.id!==fd.tariff.id){ return true; }
        if(fd.iniCLength!==fd.cLength){ return true; }
        if(fd.iniPromo.id!==fd.promo.id&&fd.iniPromo.id!==undefined){ return true; }
        return false;
      }
    },
  }
</script>

<style lang="scss" scoped></style>
